<template>
  <div id="rsihwl">
    <b-tabs v-model="tabIndex" position="is-centered" type="is-boxed" size="is-medium">
      <b-tab-item label="区服列表">
        <b-table :data="regionals" ref="table" paginated backend-pagination
          :per-page="perPage" :total="total" :current-page="currentPage"
          detailed detail-key="r"
          @page-change="getRegionals">
          <template slot-scope="props">
            <b-table-column field="status" label="状态" width="80" centered>
              <b-tag :type="props.row.status===1?'is-success':'is-light'">{{ props.row.status===1?'已启用':'已禁用'}}</b-tag>
            </b-table-column>
            <b-table-column field="id" label="regional" width="40" numeric centered>{{ props.row.r}}</b-table-column>
            <b-table-column field="name" label="名称">{{ props.row.name}}</b-table-column>
            <b-table-column label="loginkey" width="40">{{ props.row.loginkey }}</b-table-column>
            <b-table-column label="平台" width="80">{{ pfTypesDict[props.row.pftype] }}</b-table-column>
            <b-table-column label="操作">
              <div class="buttons">
                <button class="button is-warning" @click="onRegionalEditClick(props.row.r)">修改</button>
                <button class="button is-info" @click="onRegionalRelationClick(props.row)">查看关系</button>
              </div>
            </b-table-column>
          </template>
          <template slot="detail" slot-scope="props">
            <pre>{{ props.row.value }}</pre>
          </template>
          <template slot="bottom-left">
            <b>总计：</b>{{ total }}
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item label="增加">
        <section>
          <b-field horizontal label="名称" width="100">
            <b-input v-model="editorR.name" placeholder="输入名称"></b-input>
          </b-field>
          <b-field horizontal label="Regional">
            <b-input v-model.number="editorR.r" placeholder="输入regional"></b-input>
          </b-field>
          <b-field horizontal label="loginkey">
            <b-select v-model.number="editorR.loginkey">
              <option v-for="v in loginKeys" :key="v.vid" :value="v.vid">{{v.name}}({{v.vid}})</option>
            </b-select>
          </b-field>
          <b-field horizontal label="配置">
            <b-input v-model="editorR.value" rows="10" type="textarea" placeholder="配置"></b-input>
          </b-field>
          <button center class="button is-danger" :disabled="!canSave" size="is-medium" @click="saveAddRegional()">保存</button>
        </section>
      </b-tab-item>
      <b-tab-item label="编辑" :disabled="!inEdit">
        <section>
          <b-field horizontal label="Regional" style="text-align:left">
            <span>{{editorR.r}}</span>
          </b-field>
          <b-field horizontal label="名称" width="100">
            <b-input v-model="editorR.name" placeholder="输入名称"></b-input>
          </b-field>
          <b-field horizontal label="loginkey">
            <b-select v-model.number="editorR.loginkey">
              <option v-for="v in loginKeys" :key="v.vid" :value="v.vid">{{v.name}}({{v.vid}})</option>
            </b-select>
          </b-field>
          <b-field horizontal label="配置">
            <b-input v-model="editorR.value" type="textarea" rows="10" placeholder="配置"></b-input>
          </b-field>
          <button :disabled="!canSave" class="button is-danger" size="is-medium" @click="saveEditorRegional()">保存</button>
        </section>
      </b-tab-item>
      <b-tab-item label="实例列表">
        <b-table :data="instances" ref="instances"
          detailed detail-key="nid"
          @page-change="getRegionals">
          <template slot-scope="props">
            <b-table-column field="nid" label="nid" width="40" numeric centered>{{ props.row.nid}}</b-table-column>
            <b-table-column field="name" label="name">{{ props.row.name}}</b-table-column>
            <b-table-column field="sid" label="sid">{{ props.row.sid }}</b-table-column>
            <b-table-column field="deploydir" label="deploydir">{{ props.row.deploydir}}</b-table-column>
            <b-table-column field="deployuri" label="deployuri">{{ props.row.deployuri}}</b-table-column>
            <b-table-column label="操作">
              <div class="buttons">
                <button class="button is-warning" @click="onUpdateClick(props.row.nid)">更新</button>
                <button class="button is-danger" @click="onReloadClick(props.row.nid)">重载</button>
                <button class="button is-info" @click="onInstanceRelationClick(props.row)">查看关系</button>
              </div>
            </b-table-column>
          </template>
          <template slot="detail" slot-scope="props">
            <pre>{{ props.row.value }}</pre>
          </template>
        </b-table>
      </b-tab-item>
    </b-tabs>
  </div>
</template>
<script>
import toml from '@iarna/toml'
import config from '@/core/config'
import type from '@/core/type'

export default {
  name: 'regionallist',
  data () {
    return {
      perPage: config.PER_PAGE,
      currentPage: 1,
      total: 0,
      tabIndex: 0,
      inEdit: false,
      pfTypes: [],
      pfTypesDict: {},
      regionals: [],
      instances: [],
      editorR: this.buildRegional(),
      loginKeys: [],
      searchR: null
    }
  },
  created () {
    this.updateTfTypes()
    this.getRegionals()
    this.getLoginKeys()
  },
  computed: {
    canSave () {
      return this.editorR.name &&
        this.editorR.r &&
        this.editorR.value &&
        this.editorR.loginkey
    }
  },
  methods: {
    updateTfTypes () {
      this.pfTypes = type.pfTypes()
      this.pfTypesDict = {}
      for (const pft of this.pfTypes) {
        this.pfTypesDict[pft.value] = pft.text
      }
    },
    buildRegional () {
      return {
        name: null,
        r: null,
        value: null,
        loginkey: null
      }
    },
    async getRegionals (page) {
      try {
        const rdata = await this.mjp.get('/rsi/hlw/regional/get/more/', { page: page || 1, per_page: this.perPage })
        this.total = rdata.total
        this.currentPage = rdata.page
        this.perPage = rdata.per_page
        this.regionals = rdata.regionals
        this.tabIndex = 0
      } catch (e) {
        console.log(e)
      }
    },
    async getInstances () {
      try {
        this.hub.showProgress(true)
        const rdata = await this.mjp.get('/rsi/instance/get/all/', { ntype: 'hlw', r: -1 })
        this.hub.showProgress(false)
        this.instances = rdata.instances
        console.warn(this.instances)
      } catch (e) {
        console.log(e)
        this.hub.showProgress(false)
      }
    },
    async getLoginKeys () {
      const result = await this.mjp.get2({
        url: '/rsi/regional/loginkey/get/all/',
        timeout: 60000
      })
      this.loginKeys = result.loginkeys
    },
    onRegionalEditClick (r) {
      this.getRegional(r)
    },
    showRelations (title, relations) {
      const messages = []
      for (const item of relations) {
        messages.push(`<tr><td>${item.rname}(${item.r})</td><td>${item.nname}</td><td>${item.sname}(${item.sid})</td><td>${item.stype}</td><td>${item.bindkey || '-'}</td></tr>`)
      }
      const message = `<div><table class="table is-bordered"><thead><tr><th>Regional</th><th>实例名称</th><th>服务器名称</th><th>服务器类型</th><th>bindkey</th></tr></thead><tbody>${messages.join('')}</tbody></table></div>`
      this.$buefy.dialog.alert({ title, message })
    },
    async onRegionalRelationClick (regional) {
      try {
        const rdata = await this.mjp.get('/rsi/hlw/relation/get/all/', { r: regional.r })
        this.showRelations(`${regional.name}(${regional.r})`, rdata.relations)
      } catch (e) {
        console.log(e)
      }
    },
    async onInstanceRelationClick (instance) {
      try {
        const rdata = await this.mjp.get('/rsi/hlw/relation/get/all/', { nid: instance.nid, r: -1 })
        this.showRelations(`${instance.name}(${instance.nid})`, rdata.relations)
      } catch (e) {
        console.log(e)
      }
    },
    async onReloadClick (nid) {
      this.$buefy.dialog.confirm({
        message: '确认重载实例？',
        type: 'is-danger',
        onConfirm: async () => {
          try {
            this.hub.showProgress(true)
            const res = await this.mjp.get('/rsi/hlw/deploy/reload/', { nid })
            console.log(res)
            this.hub.showProgress(false)
            this.message = res.message
          } catch (e) {
            this.message = e
            this.hub.showProgress(false)
          }
        }
      })
    },
    async onUpdateClick (nid) {
      this.$buefy.dialog.confirm({
        title: '确认更新实例？',
        message: '首次更新实例时，操作<strong>可能耗时 40 秒以上。</strong><br><br>仅更新实例代码和 Venv ，不会重载实例。',
        type: 'is-danger',
        onConfirm: async () => {
          try {
            this.hub.showProgress(true)
            const res = await this.mjp.get('/rsi/hlw/deploy/update/byadmin/', { nid, venv: 1, reload: 0 })
            console.log(res)
            this.hub.showProgress(false)
            this.message = res.message
          } catch (e) {
            this.message = e
            this.hub.showProgress(false)
          }
        }
      })
    },
    async getRegional (r) {
      try {
        const result = await this.mjp.get('/rsi/hlw/regional/get/', { r: r })
        this.editorR = result.regional
        this.tabIndex = 2
      } catch (e) {
        console.log(e)
      }
    },
    testToml (t) {
      try {
        toml.parse(t)
        return true
      } catch (e) {
        this.$buefy.toast.open({
          duration: 3000,
          message: 'TOML格式错误',
          position: 'is-bottom',
          type: 'is-danger'
        })
        console.log(e)
        return false
      }
    },
    async onEditSave (url) {
      if (!this.testToml(this.editorR.value)) {
        return
      }
      try {
        await this.mjp.post(url, this.editorR)
        this.$buefy.toast.open({
          message: '操作成功！',
          type: 'is-success'
        })
        this.tabIndex = 0
      } catch (e) {
        console.log(e)
      }
    },
    saveEditorRegional () {
      this.onEditSave('/rsi/hlw/regional/edit/byadmin/')
    },
    saveAddRegional () {
      this.onEditSave('/rsi/hlw/regional/add/byadmin/')
    }
  },
  watch: {
    tabIndex (to) {
      this.inEdit = to === 2
      if (to === 0) {
        this.getRegionals()
      } else if (to === 1) {
        this.editorR = this.buildRegional()
      } else if (to === 3) {
        this.getInstances()
      }
    }
  }
}
</script>
<style scoped>
#rsihwl {
  padding: 12px;
}
</style>
